module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allTopics":"All topics","notAssigned":"Not assigned","assigned":"Assigned","suggestTopics":"Suggest Topics"},"de":{"allTopics":"Alle Themen","notAssigned":"Nicht zugewiesen","assigned":"Zugewiesen","suggestTopics":"Themen vorschlagen"}}')
  delete Component.options._Ctor
}
